import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AppProvider } from "@/contexts/AppContext";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import MovieDetail from "@/pages/MovieDetail";
import EventDetail from "@/pages/EventDetail";
import Booking from "@/pages/Booking";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCancelled from "@/pages/BookingCancelled";
import MyBookings from "@/pages/MyBookings";
import MyEvents from "@/pages/MyEvents";
import Navratri from "@/pages/Navratri";
import Diwali from "@/pages/Diwali";
import Bollywood from "@/pages/Bollywood";
import Search from "@/pages/Search";
import Profile from "@/pages/Profile";
import Creators from "@/pages/Creators";
import CreatorProfile from "@/pages/CreatorProfile";
import CreateEvent from "@/pages/CreateEvent";
import OrganizerDashboard from "@/pages/OrganizerDashboard";
import Scanner from "@/pages/Scanner";
import AdminPanel from "@/pages/AdminPanel";
import Faq from "@/pages/Faq";
import OrganiserGuide from "@/pages/OrganiserGuide";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AnalyticsConsent from "@/components/AnalyticsConsent";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/movie/:id" element={<MovieDetail />} />
      <Route path="/event/:id" element={<EventDetail />} />
      <Route path="/booking/:type/:id/:showtimeId?" element={<Booking />} />
      <Route path="/booking/success" element={<BookingSuccess />} />
      <Route path="/bookings/cancelled" element={<BookingCancelled />} />
      <Route path="/bookings" element={<MyBookings />} />
      <Route path="/my-events" element={<MyEvents />} />
      <Route path="/navratri" element={<Navratri />} />
      <Route path="/diwali" element={<Diwali />} />
      <Route path="/bollywood" element={<Bollywood />} />
      <Route path="/search" element={<Search />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/creators" element={<Creators />} />
      <Route path="/creators/:id" element={<CreatorProfile />} />
      <Route path="/create-event" element={<CreateEvent />} />
      <Route path="/organiser/:eventId" element={<OrganizerDashboard />} />
      <Route path="/organizer/:eventId" element={<OrganizerDashboard />} />
      <Route path="/scanner" element={<Scanner />} />
      <Route path="/admin-panel" element={<AdminPanel />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/organiser-guide" element={<OrganiserGuide />} />
      <Route path="/organizer-guide" element={<OrganiserGuide />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppProvider>
              <AppRouter />
              <AnalyticsConsent />
              <Toaster richColors position="top-right" />
            </AppProvider>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
